import { Document, PDFViewer, Text } from "@react-pdf/renderer";
import WrapperPage from "./WrapperPDF";
import CoverPagePDF from "./CoverPagePDF";
import MotivationPage from "./MotivationPage";
import CareerReportPage from "./CareerReportPage";
import CareerPathways from "./CareerPathways";
import MarketDemandPagePDF from "./MarketDemandPagePDF";
import SubjectRecommendation from "./SubjectRecommendation";
import CertificationsPDF from "./CertificationsPDF";
import TablePDF from "./TablePDF";
import ExplorationRecommendationsPDF from "./ExplorationRecommendationsPDF";
import JourneyPagePDF from "./JourneyPagePDF";
import SummaryPagePDF from "./SummaryPagePDF";
import EndingPagePDF from "./EndingPagePDF";
import SkillMapPDF from "./SkillMapPDF";

const StudentPDF = ({ data, assets }) => {
  console.log("StudentPDF - Data received:", data);
  console.log("StudentPDF - Assets received:", assets);
  console.log("StudentPDF - Grade:", data?.grade);
  console.log("StudentPDF - Subject recommendations:", data?.[`class_${String(data?.grade)}_subject_recommendations`]);
  
  // Safety check to prevent errors
  if (!data || !assets) {
    console.log("StudentPDF - Missing data or assets, returning null");
    return null;
  }
  
  return (
    <Document>
      <WrapperPage
        showLogo={true}
        showUpper={false}
        showLower={true}
        showFooterText={true}
        showNavigation={true}
        showPageNumber={false}
        assets={assets}
      >
        <CoverPagePDF name={data.name} />
      </WrapperPage>

      <MotivationPage showPageNumber={true} assets={assets} />

      <WrapperPage
        showLogo={false}
        showUpper={true}
        showLogo2={true}
        showLower
        showFooterText
        showNavigation={false}
        showPageNumber={true}
        assets={assets}
      >
        <CareerReportPage skills={data?.guiding_star} />
      </WrapperPage>

      {data?.top_career_paths?.map((career, idx) => (
        <CareerPathways
          key={idx}
          showPageNumber={true}
          career={career}
          showHeading={idx === 0}
          assets={assets}
        />
      ))}
      <MarketDemandPagePDF
        market_demand={data?.market_demand}
        assets={assets}
        name={data?.name}
        showPageNumber={true}
      />
      <SkillMapPDF
        data={data?.skill_map}
        assets={assets}
        showPageNumber={true}
      />
      {data?.user_type === 'SCHOOL' ? (
        <SubjectRecommendation
          grade={data?.grade}
          recommendations={data?.[`class_${String(data?.grade).toLowerCase().replace(/[^a-z0-9]/g, '_')}_subject_recommendations`]}
          assets={assets}
          showPageNumber={true}
        />
      ) : (
        <CertificationsPDF
          certifications={data?.certifications_and_platforms}
          assets={assets}
          showPageNumber={true}
        />
      )}
      <TablePDF
        entrance_exam_guide={data?.entrance_exam_guide}
        name={data?.name}
        assets={assets}
        showPageNumber={true}
      />
      <ExplorationRecommendationsPDF
        recommendations={data?.exploration_recommendations}
        assets={assets}
        showPageNumber={true}
      />
      <JourneyPagePDF assets={assets} showPageNumber={true} />
      <SummaryPagePDF assets={assets} showPageNumber={true} />
      <EndingPagePDF assets={assets} />
    </Document>
  );
};

export default StudentPDF;
